import { NgModule } from '@angular/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperComponent } from './image-cropper.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ImageCropperComponent],
  imports: [CommonModule, ImageCropperModule],
  exports: [ImageCropperComponent],
})
export class CustomImageCropperModule {}
